import Typography from 'components/generics/texts/Typography';
import CancelRecurringActionModal from 'pages/profile/components/ProfileTabContent/Bank&Transfers/components/AutoDepositSection/components/RecurringDepositsList/components/CancelRecurringActionModal';
import ChevronLeft from 'public/assets/icons/chevron_left.svg';
import MoneyDollar from 'public/assets/icons/money_dollar.svg';
import { useState } from 'react';
import { RecurringAction } from 'types/recurring-action-types';
import { parseMoney } from 'utils/money_utils';
import classes from './index.module.scss';

const RecurringActionRow = ({
  recurringAction,
}: {
  recurringAction: RecurringAction;
}) => {
  const [cancellationDialogOpen, setCancellationDialogOpen] = useState(false);

  return (
    <>
      <div
        onClick={() => setCancellationDialogOpen(true)}
        className={classes.row}
      >
        <div className={classes.leftSection}>
          <div className={classes.iconContainer}>
            <MoneyDollar className={classes.icon} />
          </div>
          <div>
            <Typography className={classes.title}>
              {recurringAction.modelType}
            </Typography>
            <Typography>
              {parseMoney(recurringAction.object.amount) +
                ' / ' +
                recurringAction.interval
                  .removeSnakeCase()
                  .capitalizeFirstLetter()}
            </Typography>
          </div>
        </div>
        <div className={classes.rightSection}>
          <ChevronLeft className={classes.icon} />
        </div>
      </div>
      <CancelRecurringActionModal
        recurringActionId={recurringAction.id}
        isOpen={cancellationDialogOpen}
        onClose={() => {
          setCancellationDialogOpen(false);
        }}
      />
    </>
  );
};

export default RecurringActionRow;
